import { Routes } from '@angular/router';
import { page404 } from './pages/page404/page404';

export const routes: Routes = [
    // Auth Module (login, register, otp)
    {
        path: 'auth',
        loadChildren: () =>
            import('./auth/auth-routing.module').then((m) => m.AuthRoutingModule),
    },

    // Main Layout Module (all pages after login)
    {
        path: '',
        loadChildren: () =>
            import('./layout/layout-routing.module').then((m) => m.LayoutRoutingModule),
    },

    // Fallback
    { path: '**', component: page404 },
];
